<template>
  <div>
    <el-autocomplete
      ref="autocomplete"
      v-model="queryParams.companyName"
      :maxlength="64"
      :fetch-suggestions="querySearchAsync"
      :debounce="100"
      placeholder="请输入"
      :trigger-on-focus="true"
      @input="valueChange"
      @select="handleSelect"
      class="company-input-wrap"
    >
      <template slot-scope="{ item }">
        {{ item.name }}
      </template>
      <el-button  slot="append" @click="querySearchAsyncClick">搜索</el-button>
    </el-autocomplete>
    <CompanyInfoButton v-model="creditCode"></CompanyInfoButton>
  </div>
</template>

<script>
import { queryListByFuzzy } from "@/api/crm/company";
import CompanyInfoButton from "@/views/crm/components/companyInfoButton";

export default {
  name: "CompanyInput",
  props: {
    value: {},
    companyId: {
      type: String,
      default () {
        return null
      }
    }
  },
  data() {
    return {
      creditCode: this.companyId,
      ifClick: false, // 是否是点击触发
      queryParams: {
        pageNum: 1,
        pageSize: 10,
        companyName: this.value
      },
      lastSearchString: "",
      lastSearchResult: [],
    };
  },
  components: {
    CompanyInfoButton
  },
  created() {
    this.queryParams.companyName = this.value
    this.creditCode = this.companyId
  },
  watch: {
    value (val) {
      console.log("companyInput value watch", val);
      this.queryParams.companyName = this.value
    },
    companyId (val) {
      console.log("companyInput companyId watch", val);
      this.creditCode = this.companyId
    }
  },
  methods: {
    querySearchAsyncClick() {
      this.ifClick = true
      this.$refs.autocomplete.handleInput(this.queryParams.companyName)
      this.$refs.autocomplete.handleFocus()
    },
    querySearchAsync(queryString, cb) {
      let that = this
      console.log("queryString", queryString);
      console.log("lastSearchString", this.lastSearchString);
      console.log("lastSearchResult", this.lastSearchResult);
      console.log("ifClick", this.ifClick);
      if(!this.ifClick){
        cb([])
        return
      } else {
        if (queryString === this.lastSearchString) {
          cb(this.lastSearchResult);
          this.ifClick = false
          return;
        }
        this.lastSearchString = queryString;
        if (queryString) {
          queryListByFuzzy({companyName: queryString}).then(response => {
            this.lastSearchResult = response.data || [];
            this.ifClick = false
            cb(this.lastSearchResult);
          }).catch(error => {
            this.lastSearchResult = [];
            this.ifClick = false
            cb(this.lastSearchResult);
          });
        } else {
          this.lastSearchResult = [];
          cb(this.lastSearchResult);
        }
      }
    },
    handleSelect (item) {
      console.log("companyInput handleSelect", item);
      this.creditCode = item.creditCode
      this.queryParams.companyName = item.name
      this.lastSearchString = item.name
      this.$emit('input', item.name)
      this.$emit('change', item.name, item.creditCode)
    },
    valueChange (val) {
      console.log("companyInput valueChange", val);
      this.creditCode = null
      this.$emit('input', val)
      this.$emit('change', val, null)
    }
  }
};
</script>
<style lang='scss'>
.company-input-wrap {
  display: block;
  .el-input{
    min-width: 200px;
  }
  .el-autocomplete-suggestion li {
    overflow: visible;
  }
}
</style>
